import { AddCircle, CheckCircle } from '@mui/icons-material';
import { Box, Button, Card, CardActions, Typography } from '@mui/material';
import { FC } from 'react';
import { TPlanFilterItemProps } from './types';

export const PlanFilterItem: FC<TPlanFilterItemProps> = ({ name, text, checked, onChecked }) => {
	return (
		<Button
			variant="contained"
			color="primary"
			sx={{
				textTransform: 'none',
				borderRadius: '12px',
				fontSize: '1rem',
				p: '0px 6px 2px 5px',
				maxWidth: '220px',
				height: '58px',
				// boxShadow: checked ? 'inherit' : 'none',
				// backgroundColor: checked ? 'primary.main' : 'transparent',
				opacity: checked ? 1 : 0.5,
				justifyContent: 'start',
			}}
			onClick={onChecked}
		>
			<Box
				sx={{
					fontSize: '1rem',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'start',
					justifyContent: 'space-between',
					height: '100%',
				}}
			>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'start',
						alignItems: 'center',
						gap: '4px',
						textAlign: 'left',
					}}
				>
					{checked ? (
						<CheckCircle sx={{ fontSize: '1.1rem' }} />
					) : (
						<AddCircle sx={{ fontSize: '1.1rem' }} />
					)}

					{name}
				</Box>
				<Typography
					sx={{
						fontSize: '0.75rem',
						m: 0,
						mt: '-5px',
						lineHeight: '1rem',
						textAlign: 'left',
					}}
					gutterBottom
					// color="primary"
				>
					{text}
				</Typography>
			</Box>
		</Button>
	);
};
